/* eslint-env browser */

import * as React from 'react'

require('../../../container/client')

const axios = require('axios')
const DomHelper = require('../../../client/clientjs/dom-helper')
const ImagesTools = require('../../../client/clientjs/services/ImagesTools')
const { captureException } = require('../../../client/clientjs/services/sentry-service')

const getUploadModal = function(type) {
  return DomHelper.query(`#modal-upload-loading-${type}`)
}

const showUploadLoader = function(type) {
  const uploadModal = getUploadModal(type)
  uploadModal.querySelector('.content-loading').style.display = 'initial'
  uploadModal.querySelector('.content-success').style.display = 'none'
  uploadModal.querySelector('.content-error').style.display = 'none'
  DomHelper.addClass(uploadModal, 'is-active')
}
const showUploadSuccess = function(type) {
  const uploadModal = getUploadModal(type)
  uploadModal.querySelector('.content-loading').style.display = 'none'
  uploadModal.querySelector('.content-success').style.display = 'initial'
  uploadModal.querySelector('.content-error').style.display = 'none'
}
const showUploadError = function(type) {
  const uploadModal = getUploadModal(type)
  uploadModal.querySelector('.content-loading').style.display = 'none'
  uploadModal.querySelector('.content-success').style.display = 'none'
  uploadModal.querySelector('.content-error').style.display = 'initial'
}

const didChooseNewProfilePicture = function(type, e) {
  const file = e.target.files[0]
  const destUrl = {
    cover: '/api/users/me/coverPicture',
    profile: '/api/users/me/profilePicture',
  }[type]
  const imageSize = {
    cover: {
      width: 1200,
      height: 1200,
    },
    profile: {
      width: 800,
      height: 800,
    },
  }[type]

  showUploadLoader(type)

  new Promise(function(resolve) {
    ImagesTools.resize(file, imageSize, function(resizedF) {
      return resolve(resizedF)
    })
  })
    .then(function(imageFile) {
      const data = new FormData()
      data.append('image', imageFile)
      return axios.post(destUrl, data)
    })
    .then(function() {
      showUploadSuccess(type)
      setTimeout(function() {
        window.location.reload()
      }, 2000)
    })
    .catch(function(err) {
      captureException(err)
      showUploadError(type)
    })
}

DomHelper.onDocumentReady(function() {
  if (DomHelper.query('#file-input-cover')) {
    DomHelper.query('#file-input-cover').addEventListener('change', function(e) {
      didChooseNewProfilePicture('cover', e)
    })
    DomHelper.query('.cover-change').onclick = function() {
      DomHelper.query('#file-input-cover').click()
    }
  }
  if (DomHelper.query('#file-input-profile')) {
    DomHelper.query('#file-input-profile').addEventListener('change', function(e) {
      didChooseNewProfilePicture('profile', e)
    })
    DomHelper.query('.avatar-change').onclick = function() {
      DomHelper.query('#file-input-profile').click()
    }
  }
})

if (module.hot) {
  module.hot.accept()
}
